import React, { useState, useEffect } from "react";
import { LockOutlined, UserOutlined, MailOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Spin, notification } from "antd";
import { useNavigate } from "react-router-dom";
import AxiosCaller from "../../../authenticatie/AxiosCaller";
import { openNotificationSuccess, openNotificationError } from '../../../Components/Notification/Notification';


const ProfileScreen = () => {
  const { get, put, post } = AxiosCaller();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const modal = Modal;
  const [loading, setLoading] = useState(true);
   
  // Fetch user data when component mounts
  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      setLoading(true);
      
      const response = await get(`/users/loggedinuser`);
      
      const userData = response.data;
      
      // Set form values with the received data
      form.setFieldsValue({
        naam: userData.naam,
        email: userData.email
      });
      
      setLoading(false);
    } catch (error) {
      console.error("Error fetching user data:", error);
      openNotificationError("Fout bij het ophalen van gebruikersgegevens.", error);
      setLoading(false);
    }
  };



  const handleUpdate = async (values) => {
    if (values.wachtwoord && values.wachtwoord !== values.confirmPassword) {
      openNotificationError("Paswoorden komen niet overeen.");
      return;
    }

    try {
      setLoading(true);
      
      // Prepare update data
      const updateData = {
        naam: values.naam,
        email: values.email,
      };
      
      // Only include password if it was provided
      if (values.wachtwoord) {
        updateData.wachtwoord = values.wachtwoord;
      }
    
      await post(`/users/updateUser`, updateData);
      setLoading(false);
 
      openNotificationSuccess("Profiel succesvol bijgewerkt"); 
      
      // Reset only the password fields after successful update
      form.setFieldsValue({
        wachtwoord: '',
        confirmPassword: ''
      });
      
    } catch (error) {
      console.error("API Error:", error);
      
      openNotificationError("Fout bij bijwerken van profiel", error);  // Trigger the error notification
      setLoading(false);
    }
  };

  return (
    <div className="Screen-container">
      <h1 className="title">Profiel</h1>
      
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
          <Spin size="large" />
        </div>
      ) : (
        <Form form={form} name="profile_form" layout="vertical" onFinish={handleUpdate}>
          <Form.Item 
            name="naam" 
            label="Naam"
            rules={[{ required: true, message: "Voer uw naam in!" }, { min: 5, message: "Naam moet minimaal 5 tekens bevatten!" }]}
          > 
            <Input 
              size="large"
              placeholder="Naam" 
              prefix={<UserOutlined />} 
              style={{ fontSize: "16px", padding: "12px" }}
            />
          </Form.Item>
          
          <Form.Item 
            name="email" 
            label="E-mail"
            rules={[{ required: true, message: "Voer uw e-mail in!" }, { type: "email", message: "Voer een geldig e-mail adres in!" },{ 
              pattern: /@kouterkortrijk\.be$/, 
              message: "E-mail moet eindigen met @kouterkortrijk.be!" 
            }]}
          > 
            <Input 
              size="large"
              placeholder="Email" 
              prefix={<MailOutlined />} 
              style={{ fontSize: "16px", padding: "12px" }}
            />
          </Form.Item>

          <Form.Item 
            name="wachtwoord"
            label="Nieuw wachtwoord (laat leeg om ongewijzigd te laten)"
            rules={[{ min: 5, message: "Wachtwoord moet minimaal 5 tekens bevatten!" }]}
          > 
            <Input.Password 
              size="large"
              placeholder="Nieuw wachtwoord" 
              prefix={<LockOutlined />} 
              style={{ fontSize: "16px", padding: "12px" }}
            />
          </Form.Item>

          <Form.Item 
            name="confirmPassword" 
            label="Bevestig nieuw wachtwoord"
            dependencies={["wachtwoord"]} 
            rules={[({ getFieldValue }) => ({
              validator(_, value) {
                if (!getFieldValue("wachtwoord") || !value || getFieldValue("wachtwoord") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Paswoorden komen niet overeen!"));
              },
            })]}
          > 
            <Input.Password 
              size="large"
              placeholder="Bevestig nieuw wachtwoord" 
              prefix={<LockOutlined />} 
              style={{ fontSize: "16px", padding: "12px" }}
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              className="button" 
              size="large"
              style={{ width: "100%" }}
              loading={loading}
            >
              Bijwerken
            </Button>
          </Form.Item>
        </Form>
      )}
    </div>
  );
};

export default ProfileScreen;